<template>
  <div class="home view">
    <div class="view-content" ref="viewContent">
      <h1 id="heading">A digital 🦄 who does</h1>
      <div class="illustrations">
        <div class="illustration">
          <div id="illustration-design" style="max-width: 1020px;">
            <div class="svg-wrapper" style="padding-bottom: 30.724%;">
              <svg
                viewBox="0 0 1022 314"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g id="lines" stroke="#dddddd" stroke-width="1" fill="none" stroke-linecap="square">
                  <path d="M0,1 L1020,1" stroke="#eeeeee"></path>
                  <path d="M0,11 L1020,11"></path>
                  <path d="M0,81 L1020,81"></path>
                  <path d="M0,245 L1020,245"></path>
                  <path d="M0,313 L1020,313" stroke="#eeeeee"></path>
                </g>
                <g id="letters" fill="none" stroke-width="1.25" stroke="#FF2F89">
                  <path
                    d="M127.043187,245 L42.5631871,245 L42.5631871,11.03 L127.373187,11.03 C197.663187,11.03 244.853187,55.91 244.853187,128.18 C244.853187,200.45 197.663187,245 127.043187,245 Z M94.7031871,195.83 L125.063187,195.83 C161.033187,195.83 190.403187,175.04 190.403187,128.18 C190.403187,81.32 161.033187,60.2 125.063187,60.2 L94.7031871,60.2 L94.7031871,195.83 Z"
                    id="d"
                  ></path>
                  <path
                    d="M373.493187,185.93 L415.403187,197.81 C407.483187,226.19 381.413187,249.95 339.833187,249.95 C294.623187,249.95 254.363187,217.61 254.363187,162.5 C254.363187,109.7 293.633187,76.04 336.203187,76.04 C387.023187,76.04 418.373187,107.39 418.373187,160.19 C418.373187,167.12 417.713187,174.71 417.383187,175.7 L303.203187,175.7 C304.193187,194.18 321.023187,207.38 340.493187,207.38 C358.643187,207.38 368.873187,198.8 373.493187,185.93 Z M304.193187,143.36 L369.863187,143.36 C369.203187,130.82 360.623187,115.64 336.863187,115.64 C315.743187,115.64 305.183187,131.15 304.193187,143.36 Z"
                    id="e"
                  ></path>
                  <path
                    d="M425.933187,198.47 L468.503187,190.88 C469.163187,202.1 477.083187,212.99 494.243187,212.99 C507.113187,212.99 513.383187,206.06 513.383187,198.8 C513.383187,192.86 509.423187,187.91 497.213187,185.27 L478.403187,180.98 C443.423187,173.39 429.563187,153.59 429.563187,130.49 C429.563187,100.46 455.963187,76.04 492.593187,76.04 C540.113187,76.04 556.613187,105.74 558.263187,124.88 L516.683187,132.47 C515.363187,121.58 508.433187,112.34 493.253187,112.34 C483.683187,112.34 475.433187,117.95 475.433187,126.53 C475.433187,133.46 481.043187,137.42 488.303187,138.74 L510.083187,143.03 C544.073187,149.96 560.573187,170.42 560.573187,194.51 C560.573187,222.56 539.123187,249.95 495.233187,249.95 C443.753187,249.95 427.253187,216.62 425.933187,198.47 Z"
                    id="s"
                  ></path>
                  <path
                    d="M625.153187,245 L574.993187,245 L574.993187,80.99 L625.153187,80.99 L625.153187,245 Z M570.703187,30.83 C570.703187,14.66 583.903187,1.46 599.743187,1.46 C616.243187,1.46 629.443187,14.66 629.443187,30.83 C629.443187,47 616.243187,60.2 599.743187,60.2 C583.903187,60.2 570.703187,47 570.703187,30.83 Z"
                    id="i"
                  ></path>
                  <path
                    d="M639.243187,254.24 L683.463187,241.7 C686.763187,257.54 699.963187,269.09 718.773187,269.09 C743.853187,269.09 759.363187,256.88 759.363187,227.18 L759.363187,219.59 C753.423187,228.5 739.233187,238.07 715.473187,238.07 C671.913187,238.07 639.243187,203.75 639.243187,158.21 C639.243187,114.98 670.593187,78.02 715.473187,78.02 C742.203187,78.02 756.393187,89.9 761.013187,98.48 L761.013187,80.99 L808.863187,80.99 L808.863187,224.54 C808.863187,271.73 782.463187,312.65 721.083187,312.65 C673.893187,312.65 643.863187,283.61 639.243187,254.24 Z M724.713187,194.51 C745.173187,194.51 759.693187,180.65 759.693187,158.21 C759.693187,135.77 743.523187,121.91 724.713187,121.91 C705.903187,121.91 689.403187,135.77 689.403187,158.21 C689.403187,180.65 704.583187,194.51 724.713187,194.51 Z"
                    id="g"
                  ></path>
                  <path
                    d="M875.013187,150.95 L875.013187,245 L824.853187,245 L824.853187,80.99 L873.363187,80.99 L873.363187,99.8 C882.273187,84.29 902.403187,76.7 919.233187,76.7 C960.483187,76.7 978.963187,106.07 978.963187,142.04 L978.963187,245 L928.803187,245 L928.803187,150.62 C928.803187,134.45 920.223187,122.24 902.073187,122.24 C885.573187,122.24 875.013187,134.45 875.013187,150.95 Z"
                    id="n"
                  ></path>
                </g>
              </svg>
            </div>
          </div>
        </div>
        <div class="illustration">
          <div id="illustration-ux">UX & UI</div>
        </div>
        <div class="illustration">
          <div id="illustration-dev">
            <div class="bash">
              <div class="dollar">$</div>
              <div class="input">dev</div>
              <div class="carriage">_</div>
            </div>
          </div>
        </div>
      </div>
      <cta-link :to="'/works'">See works</cta-link>
    </div>
  </div>
</template>

<script>
import utils from "@/utils";
import { imageApi } from "@/api";
import { TweenMax, TimelineMax } from "gsap/TweenMax";
import "imports-loader?define=>false!@/assets/vendor/DrawSVGPlugin";
import "imports-loader?define=>false!@/assets/vendor/SplitText";

import CtaLink from "@/components/CtaLink";

let masterTl = null;

function initAnimation() {
  const heading = document.querySelector("h1");
  const mySplitText = new SplitText(heading, { type: "words,chars" });
  const chars = mySplitText.chars; //an array of all the divs that wrap each character
  const illustrations = document.querySelectorAll(
    ".illustrations .illustration"
  );
  masterTl = new TimelineMax({
    onComplete: function() {
      this.play(1);
    }
  });

  masterTl.staggerFrom(
    chars,
    0.3,
    { opacity: 0, y: -30, ease: Cubic.easeOut },
    0.05
  );
  masterTl.set(illustrations, { x: "0%" });
  masterTl.add(animationDesign(), 1.5);
  masterTl.to(illustrations, 0.65, { x: "-100%" });
  masterTl.add(animationUX());
  masterTl.to(illustrations, 0.65, { x: "-200%" });
  masterTl.add(animationDev());
  masterTl.to(illustrations, 0.65, { x: "-300%" });
}

function animationDesign() {
  const container = document.querySelector("#illustration-design");
  const d = container.querySelector("#d");
  const g = container.querySelector("#g");
  const n = container.querySelector("#n");
  const lines = container.querySelectorAll("#lines path");
  const letters = container.querySelectorAll("#letters path");
  const tl = new TimelineMax();
  tl.set(d, { x: "-10%" });
  tl.set(g, { x: "10%" });
  tl.set(n, { x: "20%" });
  tl.staggerFrom(lines, 0.5, { x: "-100%", ease: Cubic.easeOut }, 0.05);
  tl.staggerFrom(letters, 1, { drawSVG: "0%", ease: Linear.easeNone }, 0.05);
  tl.to(d, 0.2, { x: "-5%" }, "-=0.05");
  tl.to(d, 0.2, { x: "0%" }, "-=0.05");
  tl.to(g, 0.2, { x: "5%" }, "-=0.05");
  tl.to(g, 0.2, { x: "0%" }, "-=0.05");
  tl.to(n, 0.2, { x: "10%" }, "-=0.05");
  tl.to(n, 0.2, { x: "0%" }, "-=0.05");
  tl.staggerTo(
    letters,
    1,
    { drawSVG: "0%", ease: Linear.easeNone },
    0.05,
    "+=0.5"
  );
  tl.staggerTo(
    lines,
    0.3,
    { opacity: 0, x: "100%", ease: Cubic.easeIn },
    0.05,
    "-=0.5"
  );
  return tl;
}

function animationDev() {
  const container = document.querySelector("#illustration-dev");
  const carriage = container.querySelector(".carriage");
  const dollar = container.querySelector(".dollar");
  const input = container.querySelector(".input");
  const text = new SplitText(input, { type: "chars" });
  const chars = text.chars;
  const tl = new TimelineMax();

  tl.from(dollar, 0.3, { autoAlpha: 0, y: 30, ease: Cubic.easeOut });
  tl.set(carriage, { x: "-300%" });
  tl.set(chars, { autoAlpha: 0 });
  tl.from(carriage, 0.2, { autoAlpha: 0, ease: Cubic.easeOut });
  tl.from(chars[0], 0.01, { autoAlpha: 0 }, "+=0.25");
  tl.set(carriage, { x: "-200%" });
  tl.from(chars[1], 0.01, { autoAlpha: 0 }, "+=0.25");
  tl.set(carriage, { x: "-100%" });
  tl.from(chars[2], 0.01, { autoAlpha: 0 }, "+=0.25");
  tl.set(carriage, { x: "0%" });
  tl.set(carriage, { autoAlpha: 0 }, "+=1");
  tl.set(carriage, { autoAlpha: 1 }, "+=0.25");
  tl.set(carriage, { innerHTML: "\\" });
  tl.set(carriage, { innerHTML: "|" }, "+=0.15");
  tl.set(carriage, { innerHTML: "/" }, "+=0.15");
  tl.set(carriage, { innerHTML: "-" }, "+=0.15");
  tl.set(carriage, { innerHTML: "\\" }, "+=0.15");
  tl.set(carriage, { innerHTML: "|" }, "+=0.15");
  tl.set(carriage, { innerHTML: "/" }, "+=0.15");
  tl.to(container, 0.4, { opacity: 0, ease: Cubic.easeOut });
  return tl;
}

function animationUX() {
  const container = document.querySelector("#illustration-ux");
  const text = new SplitText(container, { type: "words, chars" });
  const words = text.words;
  const chars = text.chars;
  const tl = new TimelineMax();

  tl.from(words[0], 0.3, { autoAlpha: 0, y: -100, ease: Cubic.easeOut });
  tl.from(
    words[1],
    0.3,
    { autoAlpha: 0, y: 100, ease: Cubic.easeOut },
    "-=0.05"
  );
  tl.from(
    words[2],
    0.3,
    { autoAlpha: 0, y: -100, ease: Cubic.easeOut },
    "-=0.05"
  );
  tl.to(
    words[2],
    0.3,
    { scale: 0.95, transformOrigin: "50% 50%", ease: Cubic.easeOut },
    "+=0.5"
  );
  tl.to(
    words[2],
    0.3,
    { scale: 1, transformOrigin: "50% 50%", ease: Cubic.easeOut },
    "+=0.05"
  );
  tl.staggerTo(
    chars,
    0.3,
    { color: "#FF2F89", ease: Cubic.easeOut },
    0.075,
    "+=0"
  );
  tl.staggerTo(chars, 0.3, { opacity: 0, ease: Cubic.easeIn }, 0.075, "+=1");
  return tl;
}

export default {
  data() {
    return {
      tl: null
    };
  },
  computed: {
    seoData() {
      return {
        title: "🦄 Antti Korhonen",
        description: "I do design, UI & UX and development.",
        url: `https://www.akworks.co`,
        image: imageApi.getUrl("https://www.akworks.co/img/share.png")
      };
    }
  },
  mounted() {
    utils.setColor("#FF2F89");
    initAnimation();
  },
  destroyed() {
    masterTl.kill();
    masterTl = null;
  },
  beforeRouteLeave(to, from, next) {
    TweenMax.to(this.$refs.viewContent, 0.3, {
      opacity: 0,
      ease: Cubic.easeInOut,
      onComplete: next
    });
  },
  components: {
    CtaLink
  },
  metaInfo() {
    return {
      title: this.seoData.title,
      meta: [
        {
          name: "description",
          vmid: "description",
          content: this.seoData.description
        },
        {
          property: "og:title",
          vmid: "og:title",
          content: this.seoData.title
        },
        {
          property: "og:description",
          vmid: "og:description",
          content: this.seoData.description
        },
        {
          property: "og:type",
          vmid: "og:type",
          content: "article"
        },
        {
          property: "og:image",
          vmid: "og:image",
          content: this.seoData.image
        },
        {
          property: "og:url",
          vmid: "og:url",
          content: this.seoData.url
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.view {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;

  @media (max-width: 375px) {
    padding-top: 80px;
  }
}
.view-content {
  text-align: center;
  width: 100%;
}

.heading {
  margin-bottom: 1.5rem;

  @media (min-width: 768px) {
    margin-bottom: 2.5rem;
  }
}
.illustrations {
  display: flex;
  width: 100%;
  overflow: hidden;
  margin-bottom: 1.5rem;

  @media (min-width: 768px) {
    margin-bottom: 2.5rem;
  }
}
.illustration {
  flex: 0 0 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  & > div {
    flex: 1 1 auto;
  }
}
#illustration-ux {
  font-size: 20vw;
  font-weight: 900;
  color: #ddd;

  @media (min-width: 1440px) {
    font-size: 288px;
  }
}
.bash {
  font-family: "SFMono-Regular", Consolas, Menlo, Courier, monospace;
  font-size: 20vw;
  color: #000;
  overflow: hidden;

  @media (min-width: 1440px) {
    font-size: 288px;
  }

  .carriage {
    color: #ddd;
  }

  div {
    position: relative;
    display: inline-block;
  }
}
.svg-wrapper {
  position: relative;
  height: 0;
  width: 100%;

  svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>